module.exports = __webpack_public_path__ + "static/ruth_before_and_after-dab87c743cea0739cebc0a95c9577fee.png";